import React from 'react';
import { useAggregationLevelContext } from 'src/features/MM/contexts/AggregationLevelContext';
import { useMMDataContext } from 'src/features/MM/contexts/MMDataContext';
import { KeyMetricsGrid } from 'src/components/molecules/KeyMetricsGrid';
import { CostPerUnit } from './CostPerUnit';
import { IncrementalSales } from './IncrementalSales';
import { MediaInvestment } from './MediaInvestment';
import { Roi } from './Roi';
import { Romi } from './Romi';

export const MMKeyMetrics: React.FC = () => {
  const { romiEnabled } = useMMDataContext();
  const { aggregateLevel } = useAggregationLevelContext();

  return (
    <KeyMetricsGrid>
      <MediaInvestment aggregateLevel={aggregateLevel} />
      <IncrementalSales aggregateLevel={aggregateLevel} />
      <Roi aggregateLevel={aggregateLevel} />
      {romiEnabled ? (
        <Romi aggregateLevel={aggregateLevel} />
      ) : (
        <CostPerUnit aggregateLevel={aggregateLevel} />
      )}
    </KeyMetricsGrid>
  );
};
